<template>
    <section class="col s12">
        <p class="label-info-nao-encontrada" v-if="!analiseTecnica">Não foi realizada a análise técnica dessa ação.</p>

        <section v-else>
            <div class="card-panel" style="border: 1px solid whitesmoke;">
                <div class="row">
                    <h6 class="col s12 title">Estudantes vinculados à ação</h6>

                    <div class="col s12">
                        <table class="responsive-table">
                            <thead>
                            <tr>
                                <th>Total</th>
                                <th>Opção</th>
                                <th>Pontuação</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><span>{{ analiseTecnica.item_quantidade_estudantes_orientados }} aluno(s)</span></td>
                                <td><span>{{ analiseTecnica.item_quantidade_estudantes_orientados_opcao }}</span></td>
                                <td><span>{{ analiseTecnica.item_quantidade_estudantes_orientados_pontuacao }} ponto(s)</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
			
			<div class="card-panel" style="border: 1px solid whitesmoke;" v-if='analiseTecnica.item_carga_horaria_evento'>
                <div class="row">
                    <h6 class="col s12 title">Carga horária do evento</h6>

                    <div class="col s12">
                        <table class="responsive-table">
                            <thead>
                            <tr>
                                <th>Total</th>
                                <th>Opção</th>
                                <th>Pontuação</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><span>{{ analiseTecnica.item_carga_horaria_evento }} h</span></td>
                                <td><span>{{ analiseTecnica.item_carga_horaria_evento_opcao }}</span></td>
                                <td><span>{{ analiseTecnica.item_carga_horaria_evento_pontuacao }} ponto(s)</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!--div class="card-panel" style="border: 1px solid whitesmoke;">
                <div class="row">
                    <h6 class="col s12 title">Tempo de existência da ação</h6>

                    <div class="col s12">
                        <table class="responsive-table">
                            <thead>
                            <tr>
                                <th>Total</th>
                                <th>Opção</th>
                                <th>Pontuação</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><span>{{ analiseTecnica.item_tempo_existencia_acao }} ano(s)</span></td>
                                <td><span>{{ analiseTecnica.item_tempo_existencia_acao_opcao }}</span></td>
                                <td><span>{{ analiseTecnica.item_tempo_existencia_acao_pontuacao }} ponto(s)</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div-->

            <div class="card-panel" style="border: 1px solid whitesmoke;">
                <div class="row">
                    <h6 class="col s12 title">
                        Relatório da ação
                    </h6>

                    <div class="col s12">
                        <table class="responsive-table centered">
                            <thead>
                            <tr>
                                <th>Avaliação do item relatório da ação</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <span class="new badge blue"
                                          data-badge-caption="">{{ startCase(analiseTecnica.item_relatorio_acao) }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
			<div class="card-panel" style="border: 1px solid whitesmoke;">
                <div class="row">
                    <h6 class="col s12 title">
                        Relatório da ação extraído do SIGA
                    </h6>

                    <div class="col s12">
                        <table class="responsive-table centered">
                            <thead>
                            <tr>
                                <th>Avaliação do item relatório da ação extraído do SIGA</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <span class="new badge blue"
                                          data-badge-caption="">{{ startCase(analiseTecnica.item_relatorio_acao_siga) }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>


    </section>
</template>

<script>
export default {
    name: "demais_itens_analise_tecnica",
    props: {
        analiseTecnica: {
            type: Object,
            default: null,
        },
    },
    methods: {
        startCase(texto) {
            return _.startCase(texto)
        },
    },
}
</script>

<style scoped>

</style>
